<template lang="pug">
  v-flex#make-loans(xs12 sm12 md12 lg12)
    v-layout(justify-center row wrap)
      v-flex(xs12 sm12 md3 lg3)
      v-flex.header-loans(xs12 sm12 md6 lg6)
        h1.mb-4(v-if="$vuetify.breakpoint.mdAndUp") Cotizador
        h2.omnesRegular Ingresa el monto que necesitas:
        v-text-field.enter-amount.mt-2.mb-2(v-model="amount" ref="amount" type="tel" v-on:keypress="verifyChars($event)" @keyup.delete="clearAmountField" @keyup.enter="showPossibilities" @blur="showPossibilities")
        span.mt-3
          | El monto máximo que puedes solicitar es {{ amountMaxLoan }}
      v-flex(xs12 sm12 md3 lg3)
    transition(name="fade")
      v-layout.subheader-loans.mt-4(row wrap v-if="possibilities" justify-center)
        v-flex(xs12 sm12 md3 lg3)
        v-flex(xs11 sm12 md6 lg6)
          h2.omnesMedium(v-if="listPossibilities.length <= 1") ¡Tenemos esta opción para ti!
          h2.omnesMedium(v-else) ¡Tenemos estas opciones para ti!
          p(v-if="listPossibilities[0].periodoGraciaExtraDiferido > 0" style="color: #00A9FF !important") Recuerda que tienes {{ textoDiferido }} diferidos, según las condiciones de tu póliza.
          p(v-if="listPossibilities[0].periodoGraciaExtraDiferido > 0" style="color: #00A9FF !important") Recuerda que al encontrarte dentro del periodo diferido, los intereses se irán capitalizando hasta el inicio de pago de tus ingresos mensuales.
          h3(v-if="listPossibilities.length <= 1") Seleccionamos la alternativa que más te convenga
          h3.info--text(v-else) Selecciona la alternativa que más te convenga
        v-flex(xs12 sm12 md3 lg3)
    transition(name="fade")
      v-layout.list-of-possibilities(row wrap v-if="possibilities" justify-center)
        v-flex(xs12 sm11 md9 lg6 xl5)
          v-layout.planes(row wrap :class="[$vuetify.breakpoint.mdAndUp && listPossibilities.length > 2 ? 'justify-start' : 'justify-center']")
            v-flex(xs11 sm4 md4 lg4 v-for="(possibility, index) in listPossibilities" :key="index" :id="'plan-'+index" :class="index === 0 ? 'active' : ''")
              // Desktop
              .desktop(v-if="$vuetify.breakpoint.mdAndUp" @click="chooseOne($event, index, index+1 === listPossibilities.length ? 'last' : 'initial')")
                v-layout.icon.text.number(row wrap justify-center)
                  v-flex(sm3)
                    img(:src="iconLoans" alt="icon-posibility")
                  v-flex(sm9)
                    p Valor de cuota
                    h2.omnesSemibold.lh-1
                      | {{ currency }} {{ possibility.cuota.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
                    // CUOTA VISUALIZADA, RESTANDOLE EL DIFERIMIENTO
                    p.text-xs-center.lh-1.mt-2.pt-1.omnesRegular
                      | {{ (possibility.cuotaSeleccionada - listPossibilities[0].periodoGraciaExtraDiferido) < 2 ? 1 : possibility.cuotaSeleccionada - listPossibilities[0].periodoGraciaExtraDiferido }} cuotas
                    p(style="font-size: 12px") ({{ possibility.textoCuotaSeleccionada }})
              // Mobile
              .mobile(v-if="$vuetify.breakpoint.smAndDown" @click="chooseOne($event, index, index+1 === listPossibilities.length ? 'last' : 'initial')")
                .icon
                  img(:src="iconLoans" alt="icon-posibility")
                .text
                  p Valor de cuota
                  h2.omnesSemibold.lh-1
                    | {{ currency }} {{ possibility.cuota.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
                .divider
                .number.my-3
                  // CUOTA VISUALIZADA, RESTANDOLE EL DIFERIMIENTO
                  h2.lh-1 {{ (possibility.cuotaSeleccionada - listPossibilities[0].periodoGraciaExtraDiferido) < 2 ? 1 : possibility.cuotaSeleccionada - listPossibilities[0].periodoGraciaExtraDiferido }}
                  span.d-block.lh-1 cuotas
          // DISCLAIMER
          v-layout.disclaimer(row wrap v-if="disclaimer" justify-center)
            v-flex.content__wrap(xs12 sm8 md9 lg7)
              p.lh-1.px-2
                | Para prestarte {{ currency }} {{ ((disclaimerItems || { monto: 0 }).monto).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }} en {{ (disclaimerItems.cuota - listPossibilities[0].periodoGraciaExtraDiferido) < 2 ? 1 : disclaimerItems.cuota - listPossibilities[0].periodoGraciaExtraDiferido }} cuotas, descontaremos de tu devolución final {{ currency }} {{ parseFloat((disclaimerItems.devolucionActual - possibilitySelected.devolucionFinal).toFixed(2)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }} al momento de finalizar la vigencia de tu póliza.
    transition(name="fade")
      v-layout.actions(row wrap v-if="possibilities" justify-center)
        v-flex.mt-2.mb-4(xs11 sm7 md4 lg3)
          v-layout(row wrap)
            v-flex
              v-select(v-if="listPossibilities.length > 1 || otherQuote !== null" :items="items" placeholder="Elige otro número de cuotas" v-model="otherQuote" @change="addPlan" outline append-icon="keyboard_arrow_down")
              v-btn(color="primary" @click="goToNextStep" :disabled="!possibilitySelected") Continuar
</template>

<script>
import quoter from './../../interfaces/quoter'
import { mapActions, mapGetters } from 'vuex'
import Functionalities from '../../interfaces/functionalities'
import trackingMixin from '../../mixins/trackingMixin'
export default {
  mixins: [trackingMixin],
  props: ['uniqueTrackId'],
  data () {
    return {
      amountMinLoan: 0,
      amountMaxLoan: 0,
      quoteSelected: 0,
      otherQuote: null,
      disclaimer: false,
      possibilities: false,
      descountFinal: 0,
      amount: null,
      textoDiferido: null,
      onboarding: 0,
      length: 3,
      items: [],
      listPossibilities: [],
      possibilitySelected: null,
      currency: null,
      iconLoans: require('./../../assets/loans/icons/icon-policy.svg'),
      disclaimerItems: {
        monto: null,
        cuota: null,
        devolucionActual: null,
        periodoDiferido: null,
        devolucionFinal: null
      },
      amplitude: {
        events: {
          loanOperation: 'Operación Prestamo'
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['getInformacionPrestamo', 'setTrackingClient']),
    ...mapActions('event', ['eventLog']),
    chooseOne (evt, pos, position = 'initial') {
      // REMOVE/ADD CLASS ACTIVE FOR FLEX DIVs
      var possibilities = document.querySelectorAll('.list-of-possibilities .flex .layout .flex')
      for (var i = 0; i < possibilities.length; i++) {
        possibilities[i].classList.remove('active')
      }
      if (evt.target.parentNode.classList.contains('text') || evt.target.parentNode.classList.contains('icon') || evt.target.parentNode.classList.contains('number')) {
        evt.target.parentElement.parentElement.parentElement.classList.add('active')
        evt.target.parentElement.parentElement.classList.add('active')
      } else if (evt.target.parentNode.classList.contains('flex') || evt.target.parentNode.classList.contains('layout')) {
        evt.target.parentElement.parentElement.parentElement.parentElement.classList.add('active')
        // evt.target.parentElement.parentElement.parentElement.classList.add('active')
        // evt.target.parentElement.parentElement.classList.add('active')
      } else if (evt.target.classList.contains('desktop') || evt.target.classList.contains('mobile')) {
        evt.target.parentElement.classList.add('active')
      } else {
        evt.target.parentElement.parentElement.classList.add('active')
      }
      // SAVE THE POSSIBILITY SELECTED
      this.possibilitySelected = this.listPossibilities[pos]
      let amountSetted = this.amount
      amountSetted = parseFloat(this.amount.toString().replace(this.currency, '').replace('$', '').replace('S', '').replace('/', '').replace(',', ''))
      // SHOW DISCLAIMER IF CHOOSE LAST POSSIBILITY
      if (amountSetted >= this.possibilitySelected.prestamoMaxGracia) {
        if (position === 'last') {
          // PUT TEXT IN DISCLAIMER
          this.disclaimerItems.monto = this.amount
          this.disclaimerItems.cuota = this.possibilitySelected.cuotaSeleccionada
          this.disclaimerItems.periodoDiferido = this.possibilitySelected.periodoDiferido
          this.disclaimerItems.devolucionActual = this.possibilitySelected.devolucionOriginal
          this.disclaimerItems.devolucionFinal = this.currency + ' ' + this.possibilitySelected.devolucionFinal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          this.disclaimer = true
        } else {
          this.disclaimer = false
        }
      }
    },
    verifyChars (evt) {
      this.possibilities = false
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if (!(/^[0-9]*\.?[0-9]*$/).test(evt.key) && charCode !== 8) {
        evt.preventDefault()
      }
      if ((this.amount !== null) && (typeof this.amount === 'string')) {
        if (this.amount.indexOf('.') > -1 && this.amount.substring(this.amount.indexOf('.')).length > 2) {
          evt.preventDefault()
        }
      }
    },
    clearAmountField () {
      this.possibilities = false
      this.amount = null
    },
    showPossibilities () {
      this.otherQuote = null
      if (this.amount != null) {
        this.amount = parseFloat((this.amount.toString().replace(this.currency, '').replace('$', '').replace('S', '').replace('/', '')).split(',').join(''))
        this.amountMaxLoan = parseFloat((this.amountMaxLoan.toString().replace(this.currency, '').replace('S', '').replace('/', '')).split(',').join(''))
        this.items = []
        this.items.push({ text: 'Elegir otro número de cuotas', value: null })
        this.disclaimer = false
        let moreFieldsLoans = quoter.calculateMoreFields(this.amount, this.otherQuote)
        const logEventData = {
          categoria: 'Préstamos',
          nombre: 'Cotización de Préstamo',
          datos: {
            monto: this.amount,
            montoMinimo: this.amountMinLoan,
            montoMaximo: this.amountMaxLoan,
            numeroPoliza: localStorage.getItem('selPol'),
            cotizacion: moreFieldsLoans
          }
        }
        // CHECK IF AMOUNT ENTER FOR USER IS GREATER OR LESS THAN
        if (this.amount > this.amountMaxLoan) {
          this.possibilities = false
          this.amountMaxLoan = this.currency + ' ' + this.amountMaxLoan.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // FORMAT NUMBERS TO STRING
          
          this.trackValidationPopup(`El monto solicitado no puede exceder el monto maximo de ${this.amountMaxLoan}`)
          
          this.$swal({
            title: 'Atención',
            text: 'El monto solicitado no puede exceder el monto máximo de ' + this.amountMaxLoan,
            type: 'error',
            confirmButtonText: 'Entendido'
          })
          return false
        } else if (this.amount < this.amountMinLoan) {
          this.possibilities = false
          this.amountMaxLoan = this.currency + ' ' + this.amountMaxLoan.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // FORMAT NUMBERS TO STRING
          const minLoanAmount = (this.currency === 'S/') ? quoter.loanLimits.min.PEN : quoter.loanLimits.min.USD
          this.$swal({
            title: 'Atención',
            text: `El monto solicitado no puede ser menor al monto mínimo de ${this.currency} ${minLoanAmount.toLocaleString()}.${this.currency === '$' ? ' Tipo de cambio: 3.75' : ''}`,
            type: 'error',
            confirmButtonText: 'Entendido'
          })
          return false
        } else if (!this.amount) {
          this.amountMaxLoan = this.currency + ' ' + this.amountMaxLoan.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // FORMAT NUMBERS TO STRING
          this.amount = ''
          return false
        }
        // STORING ALL QUOTES OF LOAN REQUEST
        this.listPossibilities = moreFieldsLoans
        // SET INFORMATION FOR DIFERIDOS
        if (this.listPossibilities[0].periodoGraciaExtraDiferido >= 12) {
          this.textoDiferido = parseInt(this.listPossibilities[0].periodoGraciaExtraDiferido / 12) + ' años'
          if (this.listPossibilities[0].periodoGraciaExtraDiferido % 12 > 0) {
            this.textoDiferido += ' con ' + parseInt(this.listPossibilities[0].periodoGraciaExtraDiferido % 12) + ' meses'
          }
        } else {
          this.textoDiferido = this.listPossibilities[0].periodoGraciaExtraDiferido + ' meses'
        }
        // SELECT THE FIRST OPTION
        this.possibilitySelected = moreFieldsLoans[0]
        // [SEND TRACKING]
        let hashT = [{
          categoria: 'Prestamos RPP-IFP',
          trackingId: this.uniqueTrackId,
          screen: 'cotizador',
          document: this.basicInfo.numeroDocumento,
          name: this.basicInfo.nombres,
          email: this.basicInfo.correo,
          phone: this.basicInfo.celular,
          data: '',
          errorType: '',
          errorData: '',
          date: Date.now()
        }]
        this.setTrackingClient(hashT)
        // [SEND TRACKING]
        // SHOW DISCLAIMER IF ONE OPTION APPEAR
        if (this.amount >= this.possibilitySelected.prestamoMaxGracia) {
          if (this.listPossibilities.length < 2) {
            this.disclaimer = true
            // PUT TEXT IN DISCLAIMER
            this.disclaimerItems.monto = this.amount
            this.disclaimerItems.cuota = this.possibilitySelected.cuotaSeleccionada
            this.disclaimerItems.periodoDiferido = this.possibilitySelected.periodoDiferido
            this.disclaimerItems.devolucionActual = this.possibilitySelected.devolucionOriginal
            this.disclaimerItems.devolucionFinal = this.currency + ' ' + this.possibilitySelected.devolucionFinal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          }
        }
        this.eventLog(logEventData)
        // FORMAT NUMBERS TO STRING
        this.amountMaxLoan = this.currency + ' ' + this.amountMaxLoan.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        this.amount = this.currency + ' ' + this.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        // COMPLETE OTHER QUOTES
        let minCuota = moreFieldsLoans[moreFieldsLoans.length - 1].cuotaSeleccionada
        // QUOTES MUST BE MULTIPLE OF 6
        while (minCuota <= moreFieldsLoans[0].maxCuotas) {
          // SE SUMA ANTES PARA NO AGARRAR LA TERCERA OPCION MOSTRADA
          minCuota++
          if (((minCuota - this.listPossibilities[0].periodoGraciaExtraDiferido) % 12 === 0) && (minCuota <= moreFieldsLoans[0].maxCuotas)) {
            this.items.push({ text: (minCuota - this.listPossibilities[0].periodoGraciaExtraDiferido) + ' cuotas', value: minCuota })
          }
        }
        this.possibilities = true
        // this.$refs.amount.blur()
      }
    },
    addPlan () {
      let self = this
      this.quoteSelected = (this.quoteSelected === 4) ? 4 : this.quoteSelected + 1
      this.amount = parseFloat(this.amount.toString().replace(this.currency, '').replace('$', '').replace('S', '').replace('/', '').replace(',', ''))
      this.amountMaxLoan = parseFloat(this.amountMaxLoan.toString().replace(this.currency, '').replace('S', '').replace('/', '').replace(',', ''))
      this.disclaimer = false
      let moreFieldsLoans = quoter.calculateMoreFields(this.amount, this.otherQuote)
      // FORMAT NUMBERS TO STRING
      this.amountMaxLoan = this.currency + ' ' + this.amountMaxLoan.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      // COMPLETE OTHER QUOTES
      let minCuota = moreFieldsLoans[moreFieldsLoans.length - 1].cuotaSeleccionada
      // QUOTES MUST BE MULTIPLE OF 12
      this.items = []
      while (minCuota <= moreFieldsLoans[0].maxCuotas) {
        if ((minCuota - this.listPossibilities[0].periodoGraciaExtraDiferido) % 12 === 0) {
          this.items.push({ text: (minCuota - this.listPossibilities[0].periodoGraciaExtraDiferido) + ' cuotas', value: minCuota })
        }
        minCuota++
      }
      // add attribute to identifier first plan selected
      moreFieldsLoans[0].flag = this.quoteSelected
      // STORING ALL QUOTES OF LOAN REQUEST
      this.listPossibilities.push(moreFieldsLoans[0])
      // Order array
      this.listPossibilities.sort((a, b) => {
        return parseFloat(a.cuotaSeleccionada) - parseFloat(b.cuotaSeleccionada)
      })
      // SELECT THE FIRST OPTION
      this.possibilitySelected = moreFieldsLoans[0]
      // SHOW DISCLAIMER IF ONE OPTION APPEAR
      if (this.amount >= this.possibilitySelected.prestamoMaxGracia) {
        if (this.listPossibilities.length < 2) {
          this.disclaimer = true
          // PUT TEXT IN DISCLAIMER
          this.disclaimerItems.monto = this.amount
          this.disclaimerItems.cuota = this.possibilitySelected.cuotaSeleccionada
          this.disclaimerItems.periodoDiferido = this.possibilitySelected.periodoDiferido
          this.disclaimerItems.devolucionActual = this.possibilitySelected.devolucionOriginal
          this.disclaimerItems.devolucionFinal = this.currency + ' ' + this.possibilitySelected.devolucionFinal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
      }
      if (this.listPossibilities.length > 6) {
        this.listPossibilities = this.listPossibilities.filter((obj) => {
          if (obj.flag !== 1) {
            obj.flag = obj.flag - 1
            return obj
          }
        })
      }
      this.listPossibilities.forEach(possiblity => {
        self.items = this.items.filter(item => {
          if (possiblity.cuotaSeleccionada !== item.value) {
            return item
          }
        })
      })
      this.amount = this.currency + ' ' + this.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      this.possibilities = true
    },
    goToNextStep () {
      let self = this
      if (self.possibilitySelected !== null) {
        this.$gtm.trackEvent({
          event: 'resumen_prestamo',
          monto_prestamo: parseFloat(self.amount.toString().replace(self.currency, '').replace('$', '').replace('S', '').replace('/', '').replace(',', '')),
          numero_cuotas: (self.possibilitySelected.cuotaSeleccionada - self.possibilitySelected.periodoGraciaExtraDiferido) < 2 ? 1 : self.possibilitySelected.cuotaSeleccionada - self.possibilitySelected.periodoGraciaExtraDiferido,
          valor_cuota: parseFloat(self.possibilitySelected.cuota.toFixed(2)),
          moneda: self.currency
        })
        let currentPoliza = self.polizasInfo.filter(f => { return f.numeroPoliza === localStorage.getItem('selPol') })
        // SET ADITIONAL DATA - EXTRACT DATA FROM POLIZAS
        self.possibilitySelected.currentRent = self.possibilitySelected.rentaPagadaMensual
        if (parseInt(currentPoliza[0].ingresosDobles) > 0) {
          self.possibilitySelected.currentRent = self.possibilitySelected.rentaPagadaMensual * 2
          self.possibilitySelected.rentaPorPagarDoble = (self.possibilitySelected.rentaPagadaMensual * 2) - self.possibilitySelected.cuota
          self.possibilitySelected.rentaPorPagarMensual = 0
        } else {
          self.possibilitySelected.rentaPorPagarDoble = 0
          self.possibilitySelected.rentaPorPagarMensual = self.possibilitySelected.rentaPagadaMensual - self.possibilitySelected.cuota
        }
        // SET AMOUNT AND CURRENCY
        self.possibilitySelected.amount = self.amount
        self.possibilitySelected.currency = self.currency
        // [SEND TRACKING]
        let hashT = [{
          categoria: 'Prestamos RPP-IFP',
          trackingId: this.uniqueTrackId,
          screen: 'Resumen',
          document: this.basicInfo.numeroDocumento,
          name: this.basicInfo.nombres,
          email: this.basicInfo.correo,
          phone: this.basicInfo.celular,
          data: '',
          errorType: '',
          errorData: '',
          date: Date.now()
        }]
        self.setTrackingClient(hashT)
        // [SEND TRACKING]
        // TRACK EVENT - AMPLITUDE
        self.$amplitude.getInstance()
          .logEvent(
            self.amplitude.events.loanOperation,
            {
              'Monto cotizado': parseFloat(self.amount.toString().replace(self.currency, '').replace('$', '').replace('S', '').replace('/', '').replace(',', '')),
              'Cuotas': (self.possibilitySelected.cuotaSeleccionada - self.possibilitySelected.periodoGraciaExtraDiferido) < 2 ? 1 : self.possibilitySelected.cuotaSeleccionada - self.possibilitySelected.periodoGraciaExtraDiferido,
              'Moneda': self.currency,
              'Opción': self.possibilitySelected.opcion
            }
          )
        const metadata = {
          numeroPoliza: currentPoliza[0].numeroPoliza,
          productoConsultado: 'RRVV',
          subproductoConsultado: currentPoliza[0].codigoProducto
        }
        self.$root.$emit('npsInactivity', {seccion: 'Préstamos - Segundo paso', metadata})
        // SET PERSISTENT DATA AND CALL A EVENT
        self.$store.commit('loans/setPossibility', self.possibilitySelected)
        self.$root.$emit('nextStep', { step: 2, possibility: self.possibilitySelected })

        this.$gtm.trackEvent({
            "event":"select_button",
            "Nombre Sección":"Zona Segura",
            "TipoElemento":"Botón",
            "TipoAccion":"Préstamo - paso 1 - continuar",
            "CTA":"Continuar"
        })
      } else {
        self.$swal({
          title: 'Atención',
          text: 'Debes seleccionar una opción antes de ir al siguiente paso',
          type: 'error',
          confirmButtonText: 'Entendido'
        })
      }
    }
  },
  mounted () {
    const self = this
    if (!Functionalities.isAvailableSilent(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
      self.$router.push('/inicio')
      return
    }
    let currentPoliza = this.polizasInfo.filter(f => { return f.numeroPoliza === localStorage.getItem('selPol') })
    const metadata = {
      numeroPoliza: currentPoliza[0].numeroPoliza,
      productoConsultado: 'RRVV',
      subproductoConsultado: currentPoliza[0].codigoProducto
    }
    this.$root.$emit('npsInactivity', {seccion: 'Préstamos - Primer paso', metadata})
    this.getInformacionPrestamo({poliza: localStorage.getItem('selPol'), vista: 'LoansFirstStep'})
      .then((res) => {
        quoter.setInfoDataPolicy(res.data)
        this.currency = (res.data.moneda.codigo === '001' || res.data.moneda.codigo === '013') ? 'S/' : '$'
        let minMaxLoan = quoter.calculateMaxMinLoan()
        this.amountMinLoan = minMaxLoan.min
        this.amountMaxLoan = this.currency + ' ' + parseFloat(minMaxLoan.max.toFixed(2).toString().replace(this.currency, '').replace('S', '').replace('/', '').replace(',', ''))
        this.amountMaxLoan = this.amountMaxLoan.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        let amountMaxLoan = this.amountMaxLoan
        // ONLY FOR DATA REMARKETING - SEND MAX AMOUNT LOAN TO PARENT COMPONENT
        this.$root.$emit('updateAmountMaxLoan', { amountMaxLoan: amountMaxLoan })
      })
      .catch(() => {
        return false
      })
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'basicInfo', 'functionsRules'])
  }
}
</script>

<style>
/** HEADER */
#make-loans .header-loans { text-align: center; }
#make-loans .header-loans h1 { font-weight: normal; }
#make-loans .header-loans p {
  margin-top: 2em;
  font-family: 'Omnes Medium';
  margin-bottom: 0;
  font-size: 14px;
}
#make-loans .header-loans .enter-amount {
  padding-top: 0;
  width: 42%;
  /* margin-top: 0!important; */
  margin: 0 auto;
  background-image: url('../../assets/formpp/editar-azul.svg');
  background-position-x: right;
  background-position-y: 3px;
  background-size: 28px;
}

#make-loans .header-loans .enter-amount .v-input__control .v-text-field__details { display: none; }
#make-loans .header-loans span {
  font-size: 12px;
  color: rgba(0,0,0,0.54);
}
/** SUBHEADER */
#make-loans .subheader-loans { margin-top: 3em; }
#make-loans .subheader-loans .flex { text-align: center; }
#make-loans .subheader-loans .flex p {
  font-family: 'Omnes Medium';
  margin-bottom: 0;
  font-size: 16px;
}
#make-loans .subheader-loans .flex span { color: rgba(0,0,0,0.54); }
/** BODY - POSSIBILITIES */
#make-loans .list-of-possibilities .flex .layout .flex p:first-of-type + p {
  font-family: 'Omnes Medium';
  font-size: 22px;
  line-height: 1;
  margin: 0 auto;
  width: 52%;
  text-align: center;
  border-bottom: 1px solid #FFF;
  padding-bottom: 9px;
  margin-bottom: 9px;
}
#make-loans .list-of-possibilities .flex .layout .flex p:first-of-type + p + p { margin-bottom: 15px !important; }
#make-loans .list-of-possibilities .flex .layout .flex:not(.no-border) {
  text-align: center;
  cursor: pointer;
}
#make-loans .list-of-possibilities .flex .layout .flex img {
  margin-top: 15px;
  background-color: #fff;
  border-radius: 70px;
  width: 3rem;
}
/** INACTIVE */
/* #make-loans .list-of-possibilities .flex .layout:not(.disclaimer) .flex:first-of-type:not(.no-border) { border-left: 1px solid #DEDEDE; } */

#make-loans .list-of-possibilities .flex .layout .flex.no-border {
  border: 0;
  border-radius: 0;
}
#make-loans .list-of-possibilities .flex .layout .flex p {
  color: #242424;
  margin-bottom: 0;
}
#make-loans .list-of-possibilities .flex .layout .flex p:first-of-type { color: #1f1f1f; }
/** ACTIVE */
#make-loans .list-of-possibilities .flex .layout.planes #plan-1.active+#plan-0 {
  border-top: none;
}
#make-loans .list-of-possibilities .flex .layout .flex.active {
  background-color: #0855C4;
  border-radius: 8px;
  border-right: 0;
}
#make-loans .list-of-possibilities .flex .layout .flex.active h2 { font-family: 'Omnes Semibold' }
#make-loans .list-of-possibilities .flex .layout .flex.active p,
#make-loans .list-of-possibilities .flex .layout .flex.active h2,
#make-loans .list-of-possibilities .flex .layout .flex.active h3,
#make-loans .list-of-possibilities .flex .layout .flex.active span {
  color: #fff;
  margin-bottom: 0;
}
#make-loans .list-of-possibilities .planes h2 {
  font-size: 27px;
}
#make-loans .v-text-field .v-input__control .v-input__append-inner .v-input__icon i {
  color: #0855C4 !important;
  caret-color: #0855C4 !important;
}
#make-loans .v-text-field .v-input__control .v-input__slot {
  margin-bottom: 5px;
}
#make-loans .v-text-field .v-input__control .v-text-field__slot input {
  font-family: 'Omnes Semibold';
  font-size: 29px;
  text-align: center;
  max-height: 100%;
  /* padding: 0; */
  padding: 0 14px 4px 0;
}
/** FOOTER */
#make-loans button {
  margin: 0 auto;
  border-radius: 5px;
  background-color: rgb(234,12,144) !important;
  border-color: rgb(234,12,144) !important;
}
#make-loans .actions .flex .layout { text-align: center; }
#make-loans .actions .flex .layout .flex .v-text-field {
  width: 47%;
  margin: 0 auto;
}
#make-loans .actions .flex .layout .flex .v-text-field .v-input__control .v-input__slot {
  min-height: auto;
  border: 1px solid rgba(0,0,0,0.54);
}
#make-loans .actions .flex .layout .flex .v-text-field .v-input__control .v-input__slot .v-select__slot label { top: 11px; }
#make-loans .actions .flex .layout .flex .v-text-field .v-input__control .v-input__slot .v-select__slot .v-select__selections { padding-top: 0; }
#make-loans .actions .flex .layout .flex .v-text-field .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
  margin-top: 9px;
  margin-bottom: 8px;
}
/** DISCLAIMER WHEN CHOOSE THE LAST POSSIBILITY */
#make-loans .list-of-possibilities .layout.disclaimer .flex { border: 0; }
#make-loans .list-of-possibilities .layout.disclaimer .content__wrap {
  background-color: #cef1ff;
  border-radius: 8px;
  margin-top: 1em;
  padding-top: 10px;
  padding-bottom: 10px;
}
#make-loans .list-of-possibilities .layout.disclaimer .flex p { color: var(--second-brand-color) !important; }
/* Small to large handset ----------- */
@media (max-width: 600px) {
  .loans .v-card .v-card__actions .steppers { margin-top: 0; }
  #make-loans .header-loans p { margin-top: 0; }
  #make-loans .header-loans .enter-amount { width: 60%; }
  #make-loans .subheader-loans { margin-top: 1em; }

  /*
  #make-loans .list-of-possibilitie .planes .icon img {

  }
  */
  #make-loans .list-of-possibilities .flex .layout .flex .mobile { overflow: hidden; }
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .icon,
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .text,
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .divider,
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .number { float: left; }
  #make-loans .list-of-possibilities .layout.disclaimer .content__wrap {
    padding-left: 10px;
    padding-right: 10px;
  }
  /** LIST OF POSSIBILITIES */
  #make-loans .list-of-possibilities .flex .layout.planes .flex:not(.active) .mobile .divider {
    background-color: #0855C4;
    border-color: #0855C4
  }
  #make-loans .list-of-possibilities .flex .layout [id*="plan"] {
  background-color: #fff;
  border-radius: 0;
  border-right: 1px solid #DEDEDE;
}
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .divider {
    height: 40px;
    width: 1px;
    margin-top: 16px;
    background-color: #fff;
    border-color: #fff;
  }
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .icon { width: 22%; }
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .icon img {
    width: 3.2rem;
    margin-top: 15px;
  }
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .text {
    margin-top: 10px;
    text-align: left;
  }
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .text p {
    width: 100%;
    border: 0;
    text-align: left;
  }
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .number { width: 24%; }
  #make-loans .list-of-possibilities .flex .layout .flex .mobile .number p {
    line-height: 1;
    margin-top: 21px;
  }
  /** LIST OF POSSIBILITIES */
  #make-loans .list-of-possibilities .flex .layout .flex { border-right: 0; }
  #make-loans .list-of-possibilities .flex .layout.planes #plan-0 {
    border-top: 1px solid #DEDEDE;
  }
  #make-loans .list-of-possibilities .flex .layout.planes .flex:not(.active) {
    border-bottom: 1px solid #DEDEDE;
  }
  #make-loans .list-of-possibilities .number h2 { font-size: 22px; }
  #make-loans .list-of-possibilities .text h2 { font-size: 25px; }
}
.fade-enter-active {
  transition: all .8s ease;
}
.fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/LoansFirstStep.vue